import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { h5Statistics } from '@ifeng-fe/mobile_statistics';
// import TopColumn from './TopColumn';
import Banner from './Banner';
import Keyword from './Keyword';
import Feed from './Feed';
import ReadEnd from './ReadEnd';
import BottomColumn from './BottomColumn';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import { getAiSummaryList } from '@src/services/api';
import { getQuery } from '@src/utils/index';

const Layout = ({ content }) => {
    const [aiSummary, setAiSummary] = useState({});
    const date = getQuery(window.location.href, 'date') || '';
    const isFromHws = window.location?.search?.includes('from=hms');

    const getAiSummaryListHandle = async () => {
        try {
            let aiSummary = await getAiSummaryList(date);

            if (!aiSummary?.chInfo) {
                aiSummary = await getAiSummaryList();
            }

            setAiSummary(aiSummary);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        h5Statistics({
            behavior: 'page',
            type: 'dtreturn',
            id: `aibrief_${date.replaceAll('-', '')}`,
            ref: encodeURIComponent(document.referrer),
            url: encodeURIComponent(window.location.href),
        });
        getAiSummaryListHandle();
    }, []);

    return (
        <>
            {/* <TopColumn content={content.headKeyword} /> */}
            {aiSummary?.chInfo && <Banner content={aiSummary.chInfo} />}
            {aiSummary?.keywords && <Keyword content={aiSummary.keywords} />}
            {aiSummary?.items?.map((item, index) => {
                return <Feed content={item} key={index} />;
            })}
            <ReadEnd />
            {
                isFromHws ? null : <BottomColumn />
            }
            {aiSummary?.shareInfo && (
                <QQShare
                    content={{
                        title: aiSummary?.shareInfo?.shareTitle || '',
                        img: aiSummary?.shareInfo?.thumbnail || '',
                        desc: aiSummary?.shareInfo?.desc || '',
                        url: window.location.href,
                        cb: () => {
                            console.log('分享成功');
                        },
                    }}
                />
            )}
        </>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
